import { render, staticRenderFns } from "./gameResultLivecasinoExportFull.vue?vue&type=template&id=fffeff90&lang=pug"
import script from "./gameResultLivecasinoExportFull.vue?vue&type=script&lang=js"
export * from "./gameResultLivecasinoExportFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports